export const LanguageCodes = [
  'de-DE', // German (Germany)
  'de-AT', // German (Austria)
  'de-CH', // German (Switzerland)
  'it-CH', // Italian (Switzerland)
  'fr-CH', // French (Switzerland)
  'en-GB', // English (UK)
  'en-US', // English (US)
  'af', // Afrikaans
  'sq', // Albanian
  'am', // Amharic
  'ar', // Arabic
  'hy', // Armenian
  'az', // Azerbaijani
  'eu', // Basque
  'be', // Belarusian
  'bn', // Bengali
  'bs', // Bosnian
  'bg', // Bulgarian
  'my', // Burmese
  'ca', // Catalan
  'ceb', // Cebuano
  'ny', // Chichewa
  'zh', // Chinese
  'zh-CN', // Chinese (Simplified)
  'zh-TW', // Chinese (Traditional)
  'co', // Corsican
  'hr', // Croatian
  'cs', // Czech
  'da', // Danish
  'nl', // Dutch
  'eo', // Esperanto
  'et', // Estonian
  'fi', // Finnish
  'fr', // French
  'fr-CA', // French (Canada)
  'gl', // Galician
  'ka', // Georgian
  'el', // Greek
  'gu', // Gujarati
  'haw', // Hawaiian
  'he', // Hebrew
  'hi', // Hindi
  'hmn', // Hmong
  'hu', // Hungarian
  'is', // Icelandic
  'ig', // Igbo
  'id', // Indonesian
  'ga', // Irish
  'it', // Italian
  'ja', // Japanese
  'jv', // Javanese
  'en-CA', // Kannada
  'kk', // Kazakh
  'km', // Khmer
  'rw', // Kinyarwanda
  'ko', // Korean
  'ku', // Kurdish
  'ky', // Kyrgyz
  'lo', // Lao
  'la', // Latin
  'lv', // Latvian
  'lt', // Lithuanian
  'lb', // Luxembourgish
  'mk', // Macedonian
  'mg', // Malagasy
  'ms', // Malay
  'ml', // Malayalam
  'mt', // Maltese
  'mi', // Maori
  'mr', // Marathi
  'mn', // Mongolian
  'ne', // Nepali
  'nb-NO', // Norwegian Bokmål
  'ps', // Pashto
  'fa', // Persian
  'pl', // Polish
  'pt', // Portuguese
  'pt-BR', // Portuguese (Brazil)
  'pt-PT', // Portuguese (Portugal)
  'pa', // Punjabi
  'ro', // Romanian
  'ru', // Russian
  'sm', // Samoan
  'gd', // Scottish Gaelic
  'sr', // Serbian
  'sn', // Shona
  'sd', // Sindhi
  'si', // Sinhala
  'sk', // Slovak
  'sl', // Slovenian
  'so', // Somali
  'st', // Southern Sotho
  'es', // Spanish
  'es-MX', // Spanish (Mexico)
  'su', // Sundanese
  'sw', // Swahili
  'sv', // Swedish
  'tl', // Tagalog
  'tg', // Tajik
  'ta', // Tamil
  'tt', // Tatar
  'te', // Telugu
  'th', // Thai
  'tr', // Turkish
  'tk', // Turkmen
  'uk', // Ukrainian
  'ur', // Urdu
  'ug', // Uyghur
  'uz', // Uzbek
  'vi', // Vietnamese
  'cy', // Welsh
  'xh', // Xhosa
  'yi', // Yiddish
  'yo', // Yoruba
  'zu', // Zulu
]
